import { useState } from 'react'

import _ from 'lodash'

import { normalizeAnnotationAbsCoordinates } from '../utils/annotationUtils'

interface UseAnnotationMarkersProps {
  currentZoom: number
  assetBoundingBox: { width: number, height: number }
  onAnnotationSelect: (annotation: any) => void
  stageRef: React.RefObject<any>
}

export const useAnnotationMarkers = ({
  currentZoom,
  assetBoundingBox,
  onAnnotationSelect,
  stageRef
}: UseAnnotationMarkersProps) => {
  const [isClickingMarker, setIsClickingMarker] = useState(false)

  const getMarkerSize = (squareSize = 40, zoom: number) => {
    // Базовый размер для маркера
    let size = squareSize

    // Коррекция размера в зависимости от зума
    if (zoom > 200) {
      size = squareSize * 0.75
    } else if(zoom > 350) {
      size = squareSize * 0.5
    }
    return size
  }

  const calculateMarkerPosition = (annotation: any) => {
    if (!assetBoundingBox) return null

    const { x, y, width, height } = normalizeAnnotationAbsCoordinates(annotation.geometry.absolute)

    const customShapeStrokeWidth = 2
    const squareSize = getMarkerSize(32, currentZoom)

    let markerDirection = 'bottom-left'
    let xPos = x + width + squareSize + customShapeStrokeWidth + 2 - 16
    let yPos = y + height - squareSize / 2 - customShapeStrokeWidth / 2 + 1
    yPos = Math.max(yPos, 0)

    // Check if the marker overflows the right edge of the asset
    if (xPos + squareSize / 2 > assetBoundingBox.width) {
      markerDirection = 'bottom-right'
      // Recalculate xPos for 'bottom-right' direction
      xPos = x - squareSize / 2 - customShapeStrokeWidth - 2
    }

    if(yPos <= squareSize) {
      markerDirection = 'top-left'
      // Recalculate yPos for 'top-left' direction
      yPos = y + squareSize / 2
    }

    return {
      x: xPos,
      y: yPos,
      direction: markerDirection,
      size: squareSize
    }
  }

  const handleMarkerClick = (annotation: any) => {
    if (onAnnotationSelect) {
      onAnnotationSelect(annotation)
    }
  }

  const handleMarkerMouseEnter = () => {
    setIsClickingMarker(true)

    const container = stageRef.current?.container()
    if (container) {
      container.style.cursor = 'pointer'
    }
  }

  const handleMarkerMouseLeave = () => {
    setIsClickingMarker(false)

    const container = stageRef.current?.container()
    if (container) {
      container.style.cursor = 'default'
    }
  }

  return {
    isClickingMarker,
    getMarkerSize,
    calculateMarkerPosition,
    handleMarkerClick,
    handleMarkerMouseEnter,
    handleMarkerMouseLeave
  }
}
